/** Soporte Ventalink: dígitos internacionales sin + (wa.me). Única fuente para planes, ayuda y enlaces de contacto. */
export const SUPPORT_WHATSAPP_NUMBER = '542966544879';
